import type { StateCreator } from 'zustand';
import type { SliceMutators } from '~/store/mutators';

export type WorkflowStep = 'matte' | 'sprite';

export type WorkflowSlice = {
  workflow: {
    step: WorkflowStep;
    /** ImageData snapshot the Sprite step renders from. Set on commit, cleared
     *  on source change. Sprite step renders this regardless of live matte edits. */
    committedCleaned: ImageData | null;
    /** Stable hash of the matte-pipeline inputs at the moment of commit. */
    committedKey: string | null;
  };
  setStep: (step: WorkflowStep) => void;
  setCommitted: (input: { cleaned: ImageData; key: string }) => void;
  resetWorkflow: () => void;
};

const INITIAL_WORKFLOW = {
  step: 'matte' as WorkflowStep,
  committedCleaned: null as ImageData | null,
  committedKey: null as string | null,
} satisfies WorkflowSlice['workflow'];

export const createWorkflowSlice: StateCreator<WorkflowSlice, SliceMutators, [], WorkflowSlice> = (
  set,
) => ({
  workflow: INITIAL_WORKFLOW,
  setStep: (step) =>
    set((s) => {
      s.workflow.step = step;
    }),
  setCommitted: ({ cleaned, key }) =>
    set((s) => {
      s.workflow.committedCleaned = cleaned;
      s.workflow.committedKey = key;
    }),
  resetWorkflow: () =>
    set((s) => {
      s.workflow = { ...INITIAL_WORKFLOW };
    }),
});
